module.exports = __webpack_public_path__ + "static/00012.43dcf914.jpg";